declare namespace $ {

	export class $shm_hitalama_map_command_palette extends $shm_hitalama_command_palette {
		benchmark_collect_notification( ): any
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=palette.view.tree.d.ts.map